<ng-container class="flex" [formGroup]="baseForm">
    <div class="my-2">

        <label class="product__option-label control-label">{{translateHelper.localize(variants.name)}}</label>

        <!--  <div class="product__option" *ngIf="variants.selectionType === 'R'">
            <div class="input-radio-label">
                <div class="input-radio-label__list">
                    <label *ngFor="let option of variants.values">
                        <input [checked]="option.isSelected" (change)="selectionChange($event.target.value)" type="radio" [value]="option.seo">
                        <span>{{ translateHelper.localize(option.value) }}</span>
                    </label>
                </div>
            </div>
        </div>
 -->
        <div class="product__option" *ngIf="variants.selectionType === 'CL'">

            <ng-container *ngIf="(variants.values| keyvalue).length <5 else selectColor">
                <div class="input-color-label">
                    <div class="input-color-label__list">
                        <label *ngFor="let option of variants.values">
                            <input [checked]="option.isSelected" (change)="selectionChange($event.target.value)" type="radio" [value]="option.seo">
                            <span [title]=" translateHelper.localize(option.name)" [style]="'background:'+option.colorValue">
                            </span>
                        </label>
                    </div>
                </div>

            </ng-container>
            <ng-template #selectColor>
                <mat-form-field appearance="outline" class="mt-1 flex-auto">
                    <!--                         <mat-label>{{"please select" | translate}}</mat-label>
-->
                    <mat-select (selectionChange)=" selectionChange($event.value)">

                        <mat-option *ngFor="let colorOption of variants.values| keyvalue" [value]="colorOption.value?.seo">
                            <div class="flex flex-row items-center">
                                <div class='select-color' [title]="colorOption.value?.name.en" [style]="'background:'+colorOption.value?.colorValue"> </div>
                                <div class="ms-2">
                                    {{colorOption.value?.name.en}}
                                </div>
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>


            </ng-template>


        </div>

        <div class="product__option" *ngIf="variants.selectionType === 'TN'">
            <div class="input-img-label">
                <div class="input-img-label__list">
                    <label *ngFor="let option of variants.values">
                        <input [checked]="option.isSelected" (change)="selectionChange($event.target.value)" type="radio" [value]="option.seo">
                        <span [title]=" translateHelper.localize(option.name)" class="img-thumb" [style]="'background-image: url('+option.img+'); background-size: cover;' ">
                        </span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group product__option" *ngIf="variants.selectionType === 'S' ||  variants.selectionType === 'R'">
            <select (change)="selectionChange($event.target.value)" class="form-control form-control-rounded">
                <option selected="true" [value]="null" disabled> --
                    {{"select_option"|translate}} -- </option>
                <option *ngFor="let option of variants.values" [selected]="option.isSelected" [value]="option.seo"> {{
                    translateHelper.localize(option.value) }}
                </option>
            </select>
        </div>
    </div>
</ng-container>

<!--  {{options.value | json}} -->